import classnames from 'classnames';
import type { CSSProperties, ReactNode } from 'react';

import { css } from '@sorare/css';

const root = css`
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: var(--half-unit);
  padding: var(--intermediate-unit) var(--unit);
  border-radius: 6px;

  @supports (mask-composite: exclude) {
    &::before {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: inherit;
      border: var(--bordered-box-border-width, 1px) solid transparent;
      background: var(--bordered-box-border) border-box;
      mask:
        linear-gradient(#fff, #fff) padding-box,
        linear-gradient(#fff, #fff);
      mask-composite: exclude;
      pointer-events: none;
    }
  }
`;

type Props = {
  border: string;
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
};

export const BorderedBox = ({ border, children, className, style }: Props) => (
  <div
    className={classnames(root, className)}
    style={{ ...style, '--bordered-box-border': border } as CSSProperties}
  >
    {children}
  </div>
);
